import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from "@ngx-translate/core";
import { LaddaModule } from 'angular2-ladda';
import { FileUploadModule } from 'ng2-file-upload';

import { CompaniesRoutingModule } from './companies-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { EquipmentModule } from '../equipment/equipment.module';

import {
  CompaniesMainComponent,
  CompanyMainComponent
} from './containers/';

import {
  CompaniesTableComponent,
  CompaniesTableFiltersComponent,
  CompanyOverviewComponent,
  CompanyUsersComponent,
  AddUserPopupComponent,
  EditUserPopupComponent,
  AddEditUserFormComponent,
  CreateDidOrderPopupComponent,
  CompanyTrialKitComponent,
  CompanySupportDevicesComponent,
  CompanyQueuesComponent,
  SetUserPasswordPopupComponent,
  CompanyEquipmentComponent,
  CreateVerificationDataPopupComponent,
  CompanyDidsComponent,
  CompanyReviewsComponent,
  VerificationDataTableComponent,
  ReplaceWithExistingDidPopupComponent,
  ReplaceWithNewDidPopupComponent,
  DidsTableComponent,
  AddPortDidPopupComponent,
  VdDetailsPopupComponent,
  EditNotesPopupComponent,
  WipLoginPopupComponent,
  CompanyDidsFiltersComponent,
  AddTestingDidPopupComponent,
  ActivateTestingDidPopupComponent,
  UploadPortabilityDocsFormComponent,
  AddVerificationDataPopupComponent,
  ConfirmActivateDidPopupComponent,
  AddPortDidFormComponent,
  DocumentsPopupComponent,
  CompanyConnectivityMainComponent,
  CompanyConnectivityOverviewComponent,
  CompanyConnectivityEquipmentComponent,
  CompanyConnectivityDetailsMainComponent,
  CompanyConnectivityEquipmentInfoPopupComponent,
  AddConnectionPopupComponent,
  AddEditConnectivityEquipmentFormComponent,
  AddConnectivityEquipmentPopupComponent,
  EditConnectivityEquipmentPopupComponent,
  ReactivateDeletedDidPopupComponent,
  CompanySmsComponent,
  AddEditSenderPopupComponent
} from './components/';
import { QueueModulePopupComponent } from './components/queue-module-popup/queue-module-popup.component';
import { CompaniesFacade } from 'src/app/domains/companies/store/facade';
import { UpdateProviderPopupComponent } from './components/update-provider-popup/update-provider-popup.component';
import { QueueRingStrategyPopupComponent } from './components/queue-ring-strategy-popup/queue-ring-strategy-popup.component';
import { CompanyIntegrationsComponent } from './components/company-integrations/company-integrations.component';
import { IntegrationDetailsPopupComponent } from './components/integration-details-popup/integration-details-popup.component';
import { EditIntegrationPopupComponent } from './components/edit-integration-popup/edit-integration-popup.component';
import { GenerateUpdatePaymentLinkPopupComponent } from './components/generate-update-payment-link-popup/generate-update-payment-link-popup.component';
import { CompanyFeatureFlagsComponent } from './components/company-feature-flags/company-feature-flags.component';

@NgModule({
    declarations: [
        CompaniesMainComponent,
        CompanyMainComponent,
        CompaniesTableComponent,
        CompaniesTableFiltersComponent,
        CompanyOverviewComponent,
        CompanyUsersComponent,
        AddUserPopupComponent,
        CreateDidOrderPopupComponent,
        EditUserPopupComponent,
        AddEditUserFormComponent,
        CompanyDidsComponent,
        CompanyTrialKitComponent,
        CompanySupportDevicesComponent,
        CompanyQueuesComponent,
        CompanyEquipmentComponent,
        SetUserPasswordPopupComponent,
        CreateVerificationDataPopupComponent,
        DidsTableComponent,
        VerificationDataTableComponent,
        ReplaceWithExistingDidPopupComponent,
        CompanyDidsFiltersComponent,
        ReplaceWithNewDidPopupComponent,
        CompanyReviewsComponent,
        AddPortDidPopupComponent,
        VdDetailsPopupComponent,
        EditNotesPopupComponent,
        WipLoginPopupComponent,
        AddTestingDidPopupComponent,
        ActivateTestingDidPopupComponent,
        UploadPortabilityDocsFormComponent,
        AddVerificationDataPopupComponent,
        ConfirmActivateDidPopupComponent,
        AddPortDidFormComponent,
        DocumentsPopupComponent,
        ReactivateDeletedDidPopupComponent,
        QueueModulePopupComponent,
        CompanyConnectivityMainComponent,
        AddConnectionPopupComponent,
        CompanyConnectivityDetailsMainComponent,
        CompanyConnectivityOverviewComponent,
        CompanyConnectivityEquipmentComponent,
        CompanyConnectivityEquipmentInfoPopupComponent,
        AddEditConnectivityEquipmentFormComponent,
        AddConnectivityEquipmentPopupComponent,
        EditConnectivityEquipmentPopupComponent,
        ReactivateDeletedDidPopupComponent,
        UpdateProviderPopupComponent,
        QueueRingStrategyPopupComponent,
        CompanyIntegrationsComponent,
        IntegrationDetailsPopupComponent,
        EditIntegrationPopupComponent,
        GenerateUpdatePaymentLinkPopupComponent,
        CompanySmsComponent,
        AddEditSenderPopupComponent,
        CompanyFeatureFlagsComponent
    ],
    imports: [
        NgbModule,
        CompaniesRoutingModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgxSkeletonLoaderModule,
        TranslateModule.forChild(),
        LaddaModule.forRoot({
            spinnerColor: 'grey',
            style: 'zoom-in'
        }),
        SharedModule,
        EquipmentModule,
        FileUploadModule
    ],
    exports: [
        CompanyDidsFiltersComponent
    ],
    providers: [
        DatePipe,
        CompaniesFacade,
        {
            provide: NgbModalConfig,
            useValue: {
                centered: true,
                backdrop: 'static'
            }
        }
    ]
})
export class CompaniesModule { }
